module.exports = __webpack_public_path__ + "img/thumbnail-395895502.72464695.jpeg";